/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { HwPlansStore } from '../stores';

export const HwPlansContext = createContext<HwPlansStore>({} as HwPlansStore);
